import AdministratorsTable from './AdministratorsTable';

export default AdministratorsTable;
